__turbopack_context__.v({
  "imageMarquee": "ImageMarquee-module-scss-module__iexpUG__imageMarquee",
  "imageMarqueeContainer": "ImageMarquee-module-scss-module__iexpUG__imageMarqueeContainer",
  "scroll": "ImageMarquee-module-scss-module__iexpUG__scroll",
  "track": "ImageMarquee-module-scss-module__iexpUG__track",
});
